import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
export const getPaymentStatusAvatar = value => {
  switch (value) {
    case 'succeeded':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "success"
      });

    case 'failed':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "error"
      });

    case 'processing':
    case 'processing_refund':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "inReview"
      });

    case 'refunded':
    case 'partially_refunded':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "thunderdome"
      });

    default:
      return undefined;
  }
};

const FormattedPaymentStatus = ({
  property,
  value
}) => {
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx("span", {
      children: EMPTY_PROPERTY_VALUE
    });
  }

  return /*#__PURE__*/_jsxs("span", {
    children: [getPaymentStatusAvatar(value), getDisplayedValue(property, value)]
  });
};

FormattedPaymentStatus.propTypes = {
  property: PropertyPropType.isRequired,
  value: PropTypes.string
};
export default FormattedPaymentStatus;